import {
  ViblastOptions,
  ViblastVideoJsPlayer
} from '@kollective-frontend/ksdk-api';

const getAttachableElement = (
  player: ViblastVideoJsPlayer,
  opts: ViblastOptions
): HTMLVideoElement | undefined => {
  if (
    player &&
    typeof player.currentTime === 'function' &&
    typeof player.duration === 'function' &&
    typeof player.off === 'function' &&
    typeof player.on === 'function' &&
    typeof player.playbackRate === 'function'
  ) {
    const ele = {
      addEventListener(name: string, listener: () => void) {
        player.on(name, listener);
      },
      removeEventListener(name: string, listener?: () => void) {
        player.off(name, listener);
      }
    } as HTMLVideoElement;
    Object.defineProperty(ele, 'playbackRate', {
      get: () => player.playbackRate()
    });
    Object.defineProperty(ele, 'duration', {
      get: () => player.duration()
    });
    Object.defineProperty(ele, 'currentTime', {
      get: () => player.currentTime()
    });
    return ele;
  }
  return opts && opts.element;
};
export default getAttachableElement;
